import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Grid, Image } from 'theme-ui'
import { baseUrl, featured_transform } from '../cloudinary-transforms'

function FeaturedIn() {
  const data = useStaticQuery(graphql`
    {
      allFeaturedIn {
        nodes {
          frontmatter {
            featured_logo
          }
        }
      }
    }
  `)
  return (
    <Grid
      sx={{
        justifyItems: 'center',
        alignItems: 'center',
      }}
      gap={20}
      columns={5}
    >
      {data.allFeaturedIn.nodes.map((node) => {
        const { featured_logo } = node.frontmatter
        return (
          <Image
            key={featured_logo}
            src={baseUrl + featured_transform + featured_logo}
          />
        )
      })}
    </Grid>
  )
}

export default FeaturedIn
